
import React, { useState } from 'react';
import { Button } from '@mui/material';
import { uploadReceipt } from '../../../services/usersServices';
import Alert from '../../../utils/Alert';
import UploadIcon from '@mui/icons-material/Upload';

const UploadReceipt = ({ rowData }) => {
    const [receiptFile, setReceiptFile] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile && !selectedFile.name.toLowerCase().match(/\.(jpg)$/)) {
            Alert("خطا!", "فقط فرمت jpg مجاز می‌باشد", "error");
            setReceiptFile(null);
        }else {
            setReceiptFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (!receiptFile) return;

        const formData = new FormData();
        formData.append('receipt', receiptFile);

        try {
            const response = await uploadReceipt(rowData.id, formData)
            if (response.status === 200) {
                window.location.reload();
            }
        }catch (error) {
            Alert("خطا!", "در آپلود رسید مشکلی پیش آمده!", "error");
        }
    };

    return (
        <>
        <div>
            <input type='file' onChange={handleFileChange} />
            <Button
                variant="contained"
                onClick={handleUpload}
            >
                <span className="ms-1">
                    <UploadIcon />
                </span>
            </Button>
        </div>
        </>
    );
}

export default UploadReceipt;